import { cn } from '@latitude/token-utils';
import * as RadioGroupPrimitive from '@radix-ui/react-radio-group';
import type { ComponentRef, Ref } from 'react';
import type { RadioGroupItemProps } from 'types';
import { radioButtonItemClasses } from 'variants';

const RadioGroupItem = ({
  className,
  ref,
  ...props
}: RadioGroupItemProps & {
  ref?: Ref<ComponentRef<typeof RadioGroupPrimitive.Item>>;
}) => {
  return (
    <RadioGroupPrimitive.Item
      ref={ref}
      className={cn(radioButtonItemClasses, className)}
      tabIndex={0}
      {...props}
    />
  );
};

RadioGroupItem.displayName = 'RadioGroupItem';

export default RadioGroupItem;
